import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=4010e3dd&"
import script from "./ProductsList.vue?vue&type=script&lang=ts&"
export * from "./ProductsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
